import { render, staticRenderFns } from "./reviewDetail.vue?vue&type=template&id=2f4cec4e&scoped=true"
import script from "./reviewDetail.vue?vue&type=script&lang=js"
export * from "./reviewDetail.vue?vue&type=script&lang=js"
import style0 from "./reviewDetail.vue?vue&type=style&index=0&id=2f4cec4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4cec4e",
  null
  
)

export default component.exports